import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';
import SuperAdminLayout from '../components/SuperAdminLayout';

/**
 * Settings Page
 * System settings for super admin
 */
const SettingsPage = () => {
  return (
    <SuperAdminLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600, color: '#2c3e50' }}>
            System Settings
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Configure system-wide settings
          </Typography>
        </Box>

        <Paper elevation={2} sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
          <SettingsIcon sx={{ fontSize: 80, color: '#5a9bd4', mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            Settings Page Coming Soon
          </Typography>
          <Typography variant="body1" color="text.secondary">
            This page will allow you to configure system-wide settings and preferences.
          </Typography>
        </Paper>
      </Container>
    </SuperAdminLayout>
  );
};

export default SettingsPage;

